var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-codics-ui-btn-body iconfont",style:({
    'height': _vm.height == null ? (_vm.size == 'normal' ? '40px' : (_vm.size == 'small' ? '30px' : '20px')) : _vm.height,
    'width': _vm.width,
    'line-height': _vm.height == null ? (_vm.size == 'normal' ? '40px' : (_vm.size == 'small' ? '30px' : '20px')) : _vm.height,
    'background': 'var(--com-codics-ui-btn-bg' + _vm.typeData[_vm.type] + '-color)',
    'color': 'var(--com-codics-ui-btn-font' + _vm.typeData[_vm.type] + '-color)',
    'border': '1px solid var(--com-codics-ui-btn-l' + _vm.typeData[_vm.type] + '-color)',
    '--hoverBgColor': 'var(--com-codics-ui-btn-hover-bg' + _vm.typeData[_vm.type] + '-color)',
    '--hoverFontColor': 'var(--com-codics-ui-btn-hover-font' + _vm.typeData[_vm.type] + '-color)',
})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }